module.exports = __webpack_public_path__ + "static/changeling-37afe9bf749f70f35d6a85a0ec238aef.png";